import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggle"
export default class extends Controller {
  static targets = ["content", "icon"]

  connect() {
    console.log("Toggle controller connected")
  }

  toggle(event) {
    // Prevent the event from bubbling up to parent elements
    event.stopPropagation()
    
    console.log("Toggle action triggered")
    
    // Toggle the hidden class on the content target
    if (this.hasContentTarget) {
      console.log("Toggling content visibility")
      this.contentTarget.classList.toggle("hidden")
    }
    
    // Rotate the icon if it exists
    if (this.hasIconTarget) {
      console.log("Rotating icon")
      this.iconTarget.classList.toggle("rotate-180")
    }
  }
}
